export default __webpack_public_path__ + "static/media/B52_17.3b096a67.webp";